// extracted by mini-css-extract-plugin
export default {"mediaColumnWrapper":"_7e74c365","mainMedia":"_8ec3ec4b","mainVideo":"_815aae5e"};